import { createIsomorphicFn } from "@tanstack/react-start";
import i18n, { initPromise, supportedLanguages } from "./init";

export const setupI18n = createIsomorphicFn()
  .server(async (locale?: string) => {
    // Wait for i18next to be initialized first
    await initPromise;

    // Server-side language detection from route parameter
    const targetLocale =
      locale && supportedLanguages.includes(locale) ? locale : "en";

    if (i18n.language !== targetLocale) {
      await i18n.changeLanguage(targetLocale);
    }

    // Ensure the translation namespace is loaded
    await i18n.loadNamespaces("translation");
  })
  .client(async (locale?: string) => {
    // Wait for i18next to be initialized first
    await initPromise;

    // Client-side language detection from route parameter
    const targetLocale =
      locale && supportedLanguages.includes(locale) ? locale : "en";

    // Always ensure the translation namespace is loaded first
    if (!i18n.hasLoadedNamespace("translation")) {
      await i18n.loadNamespaces("translation");
    }

    if (i18n.language !== targetLocale) {
      await i18n.changeLanguage(targetLocale);
    }

    // Double-check that the namespace is loaded after language change
    if (!i18n.hasLoadedNamespace("translation")) {
      await i18n.loadNamespaces("translation");
    }
  });
